import {FC, ReactElement, useContext, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import AuthService from '../services/auth.service';
import {UserContext} from '../context/userContext';
import IntroComponent from '../components/Intro.component';

const Home: FC<any> = (): ReactElement => {
    const { oktaAuthOptions } = useContext(UserContext);
    const navigate = useNavigate();


    useEffect(() => {

        // Check authentication status and redirect to signin if needed
        // Don't automatically initiate OAuth flow - let the signin page handle it
        const urlParams = new URLSearchParams(window.location.search);
        const isOktaCallback = urlParams.has('code') && urlParams.has('state');


        const currentUser = AuthService.getCurrentUser();

        if (!currentUser && !isOktaCallback) {

            // Check if we should use Okta or traditional signin
            AuthService.fetchSystemInfo().then((response) => {

                if (response.data.eimMode && oktaAuthOptions) {
                    // System is configured for Okta - redirect to signin page
                    // The signin page will handle the OAuth flow initiation
                    navigate('/react/signin');
                }
                // If not in EIM mode, just show the intro component
            }).catch(() => {
                // Silently ignore errors fetching system info, show intro component
            });
        } else if (currentUser) {
            // User is authenticated, redirect to workspace
            navigate('/react/workspace');
        }
        // Otherwise, let the component render normally (Okta callback handling or intro)
    }, [oktaAuthOptions, navigate]);

    // @ts-ignore
    return (
        <IntroComponent />
    );
};

export default Home;
